import Uppy from '@uppy/core';

/**
 * Checks if an Uppy instance has any ongoing uploads.
 *
 * @param {Uppy} uppyInstance - The Uppy instance to check.
 * @returns {boolean} - True if there are ongoing uploads, false otherwise.
 *
 * @example
 * const hasOngoingUploads = checkOngoingUploads(uppyInstance);
 * if (hasOngoingUploads) {
 *   console.log('There are ongoing uploads');
 * } else {
 *   console.log('No ongoing uploads');
 * }
 */
const checkOngoingUploads = (uppyInstance: Uppy | undefined): boolean => {
	if (!uppyInstance) return false;
	const files = uppyInstance.getFiles();
	return files.some((file: any) => file.progress.uploadComplete === false);
};

export default checkOngoingUploads;
